var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#303A46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4769 15.5858C38.1744 16.367 38.1744 17.6355 37.4769 18.4167L23.1928 34.4142C22.4953 35.1953 21.3626 35.1953 20.6652 34.4142L13.5231 26.4154C12.8256 25.6343 12.8256 24.3657 13.5231 23.5846C14.2206 22.8035 15.3533 22.8035 16.0507 23.5846L21.9318 30.1648L34.9549 15.5858C35.6523 14.8047 36.785 14.8047 37.4825 15.5858H37.4769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0d1580a83a47a3155e3d539b6897bae8.svg";
export { ForwardRef as ReactComponent };